<template>
  <div :id="'vorlage-textbaustein-' + index" class="p-2 bg-white shadow-sm s selectable-textbaustein">
    <div class="d-flex align-items-center justify-content-between">
      <span :class="{ 'text-secondary': abschnittInactive(textbaustein.textbausteinid) }">
        <font-awesome-icon v-if="abschnittInactive(textbaustein.textbausteinid)" icon="ban" class="me-2" />
        <strong>{{ textbaustein.textbaustein.name }}</strong>
        <span v-if="textbaustein.textbaustein.titel.length > 0"> ({{ textbaustein.textbaustein.titel }})</span>
      </span>

      <div class="d-flex align-items-center">
        <AbschnitteRegelnModal :vorlageTextbaustein="textbaustein" :textbaustein="textbaustein.textbaustein" :vorlage="vorlage" :index="index" />

        <button
          class="btn border-0"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#textbaustein-abschnitte-collapse-' + index"
          aria-expanded="false"
          :aria-controls="'textbaustein-abschnitte-collapse-' + index"
          :disabled="textbaustein.textbaustein.abschnitte.length == 0"
        >
          <font-awesome-icon icon="chevron-right" />
        </button>
      </div>
    </div>

    <div class="collapse mt-4" :id="'textbaustein-abschnitte-collapse-' + index">
      <div
        v-for="abschnitt in textbaustein.textbaustein.abschnitte.sort((a, b) => a.position - b.position)"
        :key="abschnitt.id"
        class="d-flex align-items-center justify-content-between ms-3 me-1 mb-3 border shadow-sm p-2"
      >
        <span :class="{ 'text-secondary': abschnittInactive(abschnitt.id) }">
          <font-awesome-icon v-if="abschnittInactive(abschnitt.id)" icon="ban" class="me-2" />

          <strong>{{ abschnitt.name }}</strong> <span v-if="abschnitt.titel.length > 0">({{ abschnitt.titel }})</span>
        </span>

        <div v-if="!abschnittInactive(textbaustein.textbausteinid)">
          <AbschnitteRegelnModal :vorlageTextbaustein="textbaustein" :textbaustein="abschnitt" :vorlage="vorlage" :index="abschnitt.id" />
        </div>
      </div>
    </div>

    <!-- <pre>{{ textbaustein.abschnittRegeln }}</pre> -->
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType } from 'vue';

  import { Vorlage, VorlageTextbaustein } from '@/models/VorlageModels';

  import AbschnitteRegelnModal from './AbschnitteRegelnModal.vue';
  //#endregion

  const { textbaustein, index } = defineProps({
    textbaustein: {
      type: Object as PropType<VorlageTextbaustein>,
      required: true,
    },

    vorlage: {
      type: Object as PropType<Vorlage>,
      required: true,
    },

    index: {
      type: Number as PropType<number>,
      default: 0,
    },
  });

  function abschnittInactive(textbausteinId: number): boolean {
    const regel = textbaustein.abschnittRegeln.find((r) => r.textbausteinId === textbausteinId);
    return regel != undefined && !regel.aktiv;
  }
</script>

<style scoped>
  .selectable-textbaustein:hover {
    cursor: grab;
    background: #fff4af !important;
    color: #000000;
  }
</style>
